export default __webpack_public_path__ + "WelcomeBackgroundImage.png";